import { inject, observer } from 'mobx-react'
import React from 'react'
import SlideSearch from '../Inputs/SlideSearch'
import SlideMenu from './SlideMenu'
import ObjectSlide from './Slides/ObjectSlide'
import PhotoSlide from './Slides/PhotoSlide'
import TemplateSlide from './Slides/TemplateSlide'
import TextSlide from './Slides/TextSlide'
import ColorPickerSlide from './Slides/ColorPickerSlide'
import FilterSlide from './Slides/FilterSlide'
import IllustrationSlide from './Slides/IllustrationSlide'

@inject('templateStore', 'photoStore', 'workAreaStore', 'illustrationStore', 'sidebarStore', 'textStore', 'elementStore') @observer
class SidebarSlide extends React.Component {

  getActiveSlide(){
    return this.props.sidebarStore.items.find(({ active }) => active)
  }

  getSlides(){
    const { 
      templateStore,
      photoStore,
      elementStore,
      textStore
    } = this.props
    const activeSlide = this.getActiveSlide()
    const layer = this.props.workAreaStore.getSelectedLayer()
    const pageObject = this.props.workAreaStore.getActivePage()
    switch(activeSlide.id){
      case 'illustrations':
        return <IllustrationSlide windowWidth={this.props.windowWidth} />
      case 'templates':
        return <TemplateSlide windowWidth={this.props.windowWidth} templateStore={templateStore} />
      case 'photos':
        return <PhotoSlide photoStore={photoStore} activeBrand={this.props.workAreaStore.activeBrand} />
      case 'gifs':
        return <ObjectSlide elementStore={elementStore} />
      case 'text':
        return <TextSlide textStore={textStore} />
      case 'color-picker':
      case 'color-picker-page':
      case 'svg-color-picker':
      case 'background':
        const isPage = !!(pageObject && pageObject.background)
        let activeColor = isPage ? pageObject.background : null
        if(!isPage){
          if(layer && layer.fillHex){
            activeColor = layer.fillHex
          }
          if(layer && layer.type === 'svgGroup'){
            activeColor = this.props.workAreaStore.editingColor
          }
        }
        if(activeSlide.id === 'background' && (!this.props.workAreaStore.activePage || this.props.workAreaStore.selectedLayer)){
          this.props.workAreaStore.deselectAllLayers()
          if(this.props.workAreaStore.pages.length === 1){
            this.props.workAreaStore.setActivePage(this.props.workAreaStore.pages[0].id)
          }
        }
        activeColor = activeSlide.id === 'background' || activeSlide.id === 'color-picker-page' ? activeColor : null
        return <ColorPickerSlide 
          activeBrand={this.props.workAreaStore.activeBrand}
          activeColor={activeColor}
          isSVGGroup={layer && layer.type === 'svgGroup'}
          groupDataSource={layer && layer.type === 'svgGroup' ? layer.dataSource : null}
          isSidebar={activeSlide.id === 'background'} 
          layerId={this.props.workAreaStore.selectedLayer} 
          slideId={activeSlide.id} 
          activePage={this.props.workAreaStore.activePage} 
        />
      case 'filters':
      case 'page-filters':
        return <FilterSlide layer={layer} pageObject={pageObject} page={this.props.workAreaStore.activePage} layerId={this.props.workAreaStore.selectedLayer} />
      case 'uploads':
        return <PhotoSlide uploadsOnly={true} photoStore={photoStore} />
      default:
        return <div />
    }
  }

  handleMouseUp(e){
    e.preventDefault()
    e.stopPropagation()
    const { clientX, clientY } = e
    const { sidebarStore } = this.props
    if(sidebarStore.selectedItem){
      sidebarStore.insertDrag(clientX, clientY)
    }
    return false
  }

  handleObjectScroll(e){
    const el = document.querySelector('.sidebar-slide.gifs')
    const scrollPos = Math.ceil(el.scrollTop + el.clientHeight)
    const { elementStore, sidebarStore } = this.props
    if(scrollPos + 200 > el.scrollHeight && !this.props.elementStore.gifsLoading && !this.props.elementStore.stickersLoading){
      if(sidebarStore.gifsOnly){
        elementStore.increaseFullGifPage()
        elementStore.getFullGifs()
      }
      if(sidebarStore.stickersOnly){
        elementStore.increaseFullStickersPage()
        elementStore.getFullStickers()
      }
    }
  }

  handleTemplateScroll(e){
    const el = document.querySelector('.sidebar-slide.templates')
    const scrollPos = Math.ceil(el.scrollTop + el.clientHeight)
    const { templateStore, sidebarStore } = this.props
    const { columnKey, columnView } = this.props.templateStore
    if(!columnView || columnKey === 'userDesigns' || columnKey === 'teamDesigns'){
      return
    }
    if(scrollPos + 350 > el.scrollHeight && templateStore.columnKey && !templateStore.publicDesigns[templateStore.columnKey].loading && templateStore.publicDesigns[templateStore.columnKey].more){
      this.props.templateStore.paginatePublicDesigns(templateStore.columnKey)
    }
  }

  handlePhotoScroll(e, uploadsOnly = false){
    const { photoStore, sidebarStore } = this.props
    let el = document.querySelector('.sidebar-slide.photos')
    if(uploadsOnly){
      el = document.querySelector('.sidebar-slide.uploads')
    }
    if(!el){
      return
    }
    const scrollPos = Math.ceil(el.scrollTop + el.clientHeight)
    const { fullScreen } = sidebarStore
    const { pageNumber } = photoStore
    let amt = 250
    if(fullScreen){
      amt = 500
      if(pageNumber > 1){
        amt += pageNumber * 100
      }
    }
    const shouldLoad = scrollPos + amt > el.scrollHeight
    if(shouldLoad && !this.props.photoStore.apiLoading && sidebarStore.apiPhotosOnly){
      photoStore.increasePage()
      photoStore.searchImages()
    }
    if(shouldLoad && !this.props.photoStore.teamAssetsLoading && sidebarStore.teamAssetsOnly && !photoStore.teamEmpty){
      photoStore.fetchTeamAssets()
    }
    if(shouldLoad && !photoStore.userAssetsLoading && !sidebarStore.projectAssetsOnly && !photoStore.isEmpty && (uploadsOnly || sidebarStore.userPhotosOnly)){
      photoStore.fetchUserImages()
    }
    if(shouldLoad && this.props.workAreaStore.activeBrand && !photoStore.projectAssetsLoading && !photoStore.isEmpty && sidebarStore.projectAssetsOnly){
      photoStore.fetchUserImages(this.props.workAreaStore.activeBrand)
    }
  }

  handleIllustrationScroll(e){
    const { illustrationStore, sidebarStore, illustrationStore: { loading, empty, collectionsOnly } } = this.props
    const el = document.querySelector('.sidebar-slide.illustrations')
    const { fullScreen } = sidebarStore
    if(!el){
      return
    }
    let amt = 250
    if(fullScreen){
      amt = 500
    }
    const scrollPos = Math.ceil(el.scrollTop + el.clientHeight)
    const shouldLoad = !empty && collectionsOnly && !loading && scrollPos + amt > el.scrollHeight
    if(shouldLoad){
      illustrationStore.increasePage()
      console.log(this.props.illustrationStore.searchTerm)
      illustrationStore.fetchCollections(this.props.illustrationStore.searchTerm)
    }
  }

  handleScrollEvent(e, slideId){
    if(slideId === 'gifs'){
      this.handleObjectScroll(e)
      return
    }
    if(slideId === 'photos' || slideId === 'uploads'){
      this.handlePhotoScroll(e, slideId === 'uploads')
      return
    }
    if(slideId === 'templates'){
      this.handleTemplateScroll(e)
      return
    }
    if(slideId === 'illustrations'){
      this.handleIllustrationScroll(e)
      return
    }
  }

  render(){
    const slide = this.getActiveSlide()
    let className = `sidebar-slide ${slide.id}`
    const { illustrationStore: ils } = this.props
    if(slide.id === 'illustrations' && ils.selectedCollection){
      className += ' open-collection'
    }
    if(!slide){
      return <div />
    }
    const hideSearch = slide.id === 'illustrations' && ils.selectedCollection
    return (
      <div 
        onScroll={e => this.handleScrollEvent(e, slide.id)} 
        className={className}
        onDragEnd={e => this.handleMouseUp(e)}
      >
        <div className='slide-menu-wrapper'>
          <SlideMenu sidebarStore={this.props.sidebarStore} />
          {slide.searchable && !hideSearch ? <SlideSearch searchValue={this.props.sidebarStore.searchValue} type={slide.id} /> : <div />}
        </div>
        {this.getSlides()}
      </div>
    )
  }

}

export default SidebarSlide